module.exports = __webpack_public_path__ + "static/media/asset2.3c821391.png";